const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const etapas = [
  {
    numero: '01',
    titulo: 'Contato',
    descricao: 'Entre em contato pelo WhatsApp ou formulário. Resposta imediata, especialmente em situações de urgência.',
    icon: 'ri-phone-line',
  },
  {
    numero: '02',
    titulo: 'Análise',
    descricao: 'Avaliação criteriosa do caso, levantamento de fatos, provas e identificação das melhores soluções jurídicas para o seu perfil.',
    icon: 'ri-search-eye-line',
  },
  {
    numero: '03',
    titulo: 'Estratégia',
    descricao: 'Definição do plano de atuação personalizado, traçando o caminho mais eficaz e seguro para o seu caso.',
    icon: 'ri-mind-map',
  },
  {
    numero: '04',
    titulo: 'Atuação',
    descricao: 'Execução da estratégia jurídica com técnica, agilidade e total dedicação, acompanhando cada etapa do processo.',
    icon: 'ri-shield-check-line',
  },
];

export default function ComoFunciona() {
  return (
    <section id="atendimento" className="py-[60px] bg-[#0A1829]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Como trabalhamos
            </span>
            <span className="h-px w-12 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-white font-light mb-4">
            Metodologia de <span className="italic text-[#E9D59C]">Trabalho</span>
          </h2>
          <p className="font-sans text-white/60 text-base max-w-xl mx-auto leading-relaxed">
            Um processo claro, estratégico e transparente — da primeira consulta à resolução definitiva do seu caso.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 relative">
          {/* Connecting line */}
          <div className="absolute top-20 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-[#B39B62]/0 via-[#B39B62]/40 to-[#B39B62]/0 hidden lg:block"></div>

          {etapas.map((etapa, index) => (
            <div key={etapa.numero} className="relative flex flex-col items-center text-center px-6 py-8">
              {/* Circle with number */}
              <div className="relative w-24 h-24 flex items-center justify-center rounded-full border-2 border-[#B39B62]/40 bg-[#B39B62]/10 mb-6 z-10">
                <div className="absolute inset-0 rounded-full bg-[#0A1829]"></div>
                <span className="relative font-serif text-3xl text-[#B39B62] font-light z-10">{etapa.numero}</span>
              </div>
              {/* Arrow connector for mobile */}
              {index < etapas.length - 1 && (
                <div className="lg:hidden absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-4 w-px h-8 bg-[#B39B62]/30"></div>
              )}
              <h3 className="font-serif text-xl text-white font-medium mb-3">{etapa.titulo}</h3>
              <p className="font-sans text-white/50 text-sm leading-relaxed">{etapa.descricao}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-6">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border-2 border-[#B39B62] text-[#B39B62] hover:bg-[#B39B62] hover:text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar com um advogado agora
          </a>
        </div>
      </div>
    </section>
  );
}
